import { AuditParams, AuditRepresentation } from "@/lib/apis/replicable/models";
import { AuditStatus, Warning } from "../typings";

export function createParam(audit: AuditRepresentation): AuditParams {
	return {
		clientId: audit.clientId,
		closed: audit.closed,
		name: audit.name,
		restitutionTemplateId: audit.restitutionTemplate.id,
		periodStart: audit.periodStart ?? "",
		currentCycleStart: audit.currentCycleStart,
		cycleLength: audit.cycleLength,
		status: audit.status,
		recurring: audit.recurring,
		dateRestored: audit.dateRestored,
		comment: audit.comment,
		whiteLabelRemoveLogo: false,
		whiteLabelShowCobhamApproved: audit.whiteLabelConfiguration.showCobhamApproved,
		whiteLabelShowCobhamHeader: audit.whiteLabelConfiguration.showCobhamHeader,
		orderId: audit.orderId,
		auditorId: audit.auditorId,
	};
}

export function getWarnings(audit: AuditRepresentation) {
	if (!audit) {
		return [];
	}

	const warnings: Warning[] = [];
	const auditStatus = AuditStatus[audit.status];

	if (auditStatus < AuditStatus.RESTORABLE && audit.scope.institutionCount === 0) {
		warnings.push(Warning.MissingInstitutions);
	}

	if (
		auditStatus >= AuditStatus.PREPARING &&
		auditStatus < AuditStatus.RESTORABLE &&
		audit.preparation.missingFileCount > 0
	) {
		warnings.push(Warning.MissingFiles);
	}

	if (
		auditStatus >= AuditStatus.PREPARING &&
		auditStatus < AuditStatus.RESTORABLE &&
		audit.preparation.missingMappingCount > 0
	) {
		warnings.push(Warning.MissingMapping);
	}

	if (
		auditStatus >= AuditStatus.PREPARING &&
		auditStatus < AuditStatus.RESTORABLE &&
		audit.preparation.missingDataCount > 0
	) {
		warnings.push(Warning.MissingData);
	}

	if (auditStatus >= AuditStatus.IN_PROGRESS && auditStatus <= AuditStatus.RESTORABLE) {
		if (audit.havePaySlipInErrorNotVisited) {
			warnings.push(Warning.HavePaySlipInErrorNotVisited);
		}

		if (audit.havePaySlipMissingData) {
			warnings.push(Warning.HavePaySlipMissingData);
		}
	}

	if (auditStatus >= AuditStatus.RESTORABLE) {
		if (audit.cycleLength > 1 && !audit.dateRestored) {
			warnings.push(Warning.MissingDateRestored);
		}

		if (!audit.comment) {
			warnings.push(Warning.MissingComment);
		}

		if (audit.missingReports) {
			warnings.push(Warning.MissingReports);
		}
	}

	return warnings;
}
